import {ButtonStyleProps, ButtonWrapper} from "./button.style";
import React, {ButtonHTMLAttributes, forwardRef, JSX, LazyExoticComponent, ReactNode} from "react";
import IconType from "../../assets/icons";
import {CustomHelper} from "../../helpers";

export type VariantType = "filled" | "outlined" | "text"
export type SizeType = "small" | "base" | "large"
export type IconPositionType = "end" | "start"
export type RoundedType = "sm" | "md" | "lg" | "xl" | "full" | "none"
type ChildrenType = ReactNode | string

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "size">, ButtonStyleProps {
    children?: ChildrenType
    /**
     * @default medium
     */
    size?: SizeType
    icon?: string | JSX.Element | LazyExoticComponent<React.FC<IconType>> | ReactNode
    /**
     * @default start
     */
    iconPosition?: IconPositionType
    /**
     * @default md
     */
    rounded?: RoundedType
    ringEffect?: boolean,
    /**
     * Use Tailwind or custom css to set your desired icon style
     */
    iconClassName?: string,
    /**
     * @default false
     */
    fullWidth?: boolean
    /**
     * @deprecated The use of `baseclassName` is no longer required. Please use `baseClassName` instead, which also supports Tailwind CSS.
     */
    baseClassName?: string
}

export const ButtonComponent = forwardRef<HTMLButtonElement, ButtonProps>(({children,fullWidth,rounded = "md",iconPosition = "start",
                                                                                    size = "base",icon,iconClassName,color,className,$type = "filled",...props}, ref) => {
    return (
        <ButtonWrapper ref={ref} {...props} className={`${className || ""} rb-button`}
                       $iconPosition={iconPosition} $rounded={rounded} $fullWidth={fullWidth}
                       $type={$type} $size={size}>
            {icon && iconPosition === "start" && CustomHelper.renderIcon(icon, iconClassName)}
            {children}
            {icon && iconPosition === "end" && CustomHelper.renderIcon(icon, iconClassName)}
        </ButtonWrapper>
    )
})